import React from "react";
import MaterialTableEmp from "../../../../../components/tables/MaterialTableEmp";

interface IProps {
  rowData?: any;
  invoicePhase?: string;
  isLoading?: boolean;
}

const InvoiceDebitAdjustmentDetails: React.FC<IProps> = ({
  rowData,
  invoicePhase,
  isLoading = false,
}) => {
  const extractDates = (input: string): string | null => {
    const datePattern = /\d{4}-\d{2}-\d{2} - \d{4}-\d{2}-\d{2}/;
    if (input == null) return null;
    const match = input?.match(datePattern);
    return match ? match[0] : null;
  };
  const materialColumns = [
    {
      title: "Bill Reference - Debit Adjustment",
      field: "invoiceNumber",
      render: (rowData) => {
        return (
          <div
            className="blueAndBold underline cursor-pointer "
            onClick={() => {
              window.open(
                `https://acumaticastg.confie.com/Main?CompanyID=Admin+Retail&ScreenId=AP301000&DocType=ADR&RefNbr=${rowData?.invoiceNumber}`,
                "_blank"
              );
            }}
          >
            {rowData?.invoiceNumber}
          </div>
        );
      },
    },
    {
      title: "Transaction Description",
      field: "transactionDescription",
      render: (rowData) => {
        let extractedDates = extractDates(rowData.transactionDescription);
        return extractedDates != null
          ? extractedDates
          : rowData.transactionDescription;
      },
    },
    {
      title: "Unit Cost",
      field: "unitCost",
      render: (rowData) => {
        return rowData.unitCost ? Number(rowData.unitCost).toFixed(2) : "0.00";
      },
    },
    {
      title: "Ext. Cost",
      field: "amount",
      render: (rowData) => {
        return rowData.amount ? Number(rowData.amount).toFixed(2) : "0.00";
      },
    },
    {
      title: "Amount",
      field: "amount",
      render: (rowData) => {
        return rowData.amount ? Number(rowData.amount).toFixed(2) : "0.00";
      },
    },
    {
      title: "Account",
      field: "account",
    },
    {
      title: "Sub Account",
      field: "subAccount",
    },
    { title: "Description", field: "description" },
  ];
  return (
    <>
      <div className="bg-white border rounded-md overflow-x-auto">
        <div className="overflow-x-auto grid grid-row">
          <MaterialTableEmp
            columns={materialColumns}
            data={
              rowData
                ? rowData?.map((c) => {
                    const { tableData, ...rows } = c;
                    return rows;
                  })
                : []
            }
            isLoading={isLoading}
            pageSize={3}
          />
        </div>
      </div>
    </>
  );
};

export default InvoiceDebitAdjustmentDetails;
